<template>
    <main id="mainCtrl" v-cloak>
        <table v-cloak id="reportsList">
            <tr>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateClinicsSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Клиники</button>
                        </template>
                    </v-loading-component>

                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_clinics.xml')" width="30" class="groupEnd" tooltip="[city]_clinics.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>

                    <v-loading-component @click="generateSitemap('generateClinicTypesSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Клиники: Типы</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_clinic_types.xml')" width="30" class="groupEnd"><i class="fa fa-link fa-xs" tooltip="[city]_clinic_types.xml"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>&nbsp;</td>
                <td nowrap>&nbsp;</td>
                <td nowrap>&nbsp;</td>
            </tr>
            <tr>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateDoctorsSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Врачи</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_doctors.xml')" width="30" class="groupEnd"><i class="fa fa-link fa-xs" tooltip="[city]_doctors.xml"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateDoctorSpecialitySitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Вр: специализации</button>
                        </template>
                    </v-loading-component>

                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_doctor_speciality.xml')" width="30" class="groupEnd" tooltip="[city]_doctor_speciality.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>

                    <v-loading-component @click="generateSitemap('generateDoctorSpecialityAreaSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Вр: спец × округа</button>
                        </template>
                    </v-loading-component>

                    <button @click="sitemapLink(public_storage+'/sitemaps/msk_doctor_specialityByArea.xml')" width="30" class="groupEnd" tooltip="[city]_doctor_specialityByArea.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateDoctorSpecialityDistrictSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Вр: спец × районы</button>
                        </template>
                    </v-loading-component>

                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_doctor_specialityByDistrict.xml')" width="30" class="groupEnd" tooltip="[city]_doctor_specialityByDistrict.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateDoctorSpecialityMetroSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Вр: спец × метро</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_doctor_specialityByMetro.xml')" width="30" class="groupEnd" tooltip="[city]_doctor_specialityByMetro.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
            </tr>
            <tr>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateStaticpagesSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Статика/справочник</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapLink(public_storage+'/sitemaps/staticpages.xml')" width="30" class="groupEnd" tooltip="staticpages.xml"><i class="fa fa-link fa-xs"></i></button>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateConsultQuestionsSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Консультации</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapLink(public_storage+'/sitemaps/consultQuestions.xml')" width="30" class="groupEnd" tooltip="consultQuestions.xml"><i class="fa fa-link fa-xs"></i></button>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateServicesSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Услуги</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapCitiesLink(public_storage+'/sitemaps/[city]_services.xml')" width="30" class="groupEnd" tooltip="[city]_services.xml"><i class="fa fa-link fa-xs"></i><i class="fa fa-link fa-xs" style="margin-left: -5px"></i></button>
                </td>
                <td nowrap>&nbsp;</td>
                <td nowrap>&nbsp;</td>

            </tr>
            <tr>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('all', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="180" class="groupBegin">Все сайтмапы</button>
                        </template>
                    </v-loading-component>
                </td>
                <td nowrap>
                    <v-loading-component @click="generateSitemap('generateMainSitemap', $event)">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['groupBegin', loadingClass]" width="150" class="groupBegin">Главный sitemap</button>
                        </template>
                    </v-loading-component>
                    <button @click="sitemapLink(public_storage + '/sitemaps/sitemap.xml')" width="30" class="groupEnd" tooltip="sitemap.xml"><i class="fa fa-link fa-xs"></i></button>
                </td>
                <td nowrap>&nbsp;</td>
                <td nowrap>&nbsp;</td>
                <td nowrap>&nbsp;</td>
            </tr>
        </table>
        <br/><br/><br/>
        <template v-for="queue in queues">
            <div width="500">
                <span>Название: {{queue.name}}</span>    <span style="float:right"> Осталось: {{queue.count}}  </span>
            </div>

        </template>
        <CitiesDialog ref="cityDialog"/>
    </main>
</template>

<script>
import { mapState } from "vuex";
import { STORAGE_PUBLIC } from "@/global/const";
import CitiesDialog from "@dialogs/admin/settings/sitemaps/CitiesDialog";
export default {
    data: function() {
        return {
            public_storage: STORAGE_PUBLIC,
            queues: []
        };
    },
    components: {
        CitiesDialog
    },
    computed: {
        ...mapState({
            cityOptions: state => state.dictionary.cityOptions,
        }),
    },
    created() {
        this.getInfo();
        setInterval(() => {
            this.getInfo();
        }, 6000);
    },
    methods: {
        getInfo(){
            this.axios.get('sitemaps/info' ,{}).then(response => {
                this.queues  =response.data;
            });
        },
        generateSitemap: function (method, btn) {
            btn.startLoadingAnimation();
            this.axios.post('sitemaps/' + method)
                .then(() => btn.stopLoadingAnimation())
                .catch(() => btn.stopLoadingAnimation());
        },
        sitemapLink: function (url, e) {
            window.open(url + '?nocache=' + (new Date()).getTime(), "_blank", "width=600, height=800");
        },

        sitemapCitiesLink: function (url, e) {
            this.$refs.cityDialog.show(url)
        }
    }
}
</script>
<style>
#reportsList button {
    width: 100%;
}
</style>
